const cartModuleAnalytics = document.querySelector('.sc-cart-module[data-analytics-cart]');

if (cartModuleAnalytics) {
  try {
    const analyticsCart = JSON.parse(cartModuleAnalytics.dataset.analyticsCart);
    if (analyticsCart.items?.length) {
      pushEcommerceEvent('view_cart', analyticsCart);
    }
  } catch (err) {
    console.error(err);
  }
}
